var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiablerieLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1322.835,
    height: 292,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 992.126h992.126V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.62715 0 0 -1.62715 -162.127 949.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56.871c0-4.643.075-8.974-.103-13.294-.021-.494-1.451-1.31-2.244-1.331-4.752-.125-9.508-.063-14.263-.063-12.421 0-24.842.06-37.262-.053-2.344-.021-3.991.673-5.569 2.366C-5.942-8.756-9.575-5.38-12.931-1.747c-.878.951-1.594 2.473-1.604 3.739a2789.247 2789.247 0 0 0-.009 41.919c.008 1.195.598 2.656 1.415 3.529 3.711 3.966 7.553 7.814 11.463 11.585.815.786 2.114 1.51 3.194 1.515 17.854.091 35.709.064 53.564.054.464 0 .929-.114 1.588-.2V46.048H-.028V30.584H56.71V16.099H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(575.127 493.104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56.609v-14.501c-1.042-.056-2.075-.157-3.108-.158-17.077-.01-34.154-.051-51.23.072-1.434.01-3.159.809-4.233 1.801A190.737 190.737 0 0 0-12.864-1.879c-.991 1.075-1.774 2.808-1.788 4.249a2250.816 2250.816 0 0 0-.006 41.332c.012 1.352.732 2.984 1.662 3.989 3.62 3.916 7.409 7.682 11.253 11.381.815.784 2.127 1.485 3.214 1.491 17.852.089 35.706.063 53.559.052.464 0 .929-.112 1.559-.193V46.011H-.052V30.592h56.623V16.16H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(854.266 493.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v14.409h56.798v15.662H.085v14.547c.915.053 1.844.153 2.774.154 17.172.009 34.345.055 51.516-.076 1.519-.011 3.352-.834 4.485-1.881 3.703-3.417 7.271-7.005 10.625-10.764 1.089-1.22 1.799-3.139 1.918-4.793.276-3.861-.115-7.769.153-11.631.209-3.008-.567-5.283-3.096-6.933-.646-.422-1.258-.895-1.896-1.352.458-.735.579-1.176.861-1.342 4.146-2.441 3.763-6.398 4.231-10.503.91-7.981-2.035-13.489-7.682-18.982-4.949-4.814-9.636-7.079-16.653-6.791-14.528.597-29.098.18-43.651.18H.021v14.719h56.887V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(376.503 509.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v14.304h55.041v45.784H.079v14.478c.986.064 1.918.178 2.85.178 16.593.011 33.187.058 49.78-.075 1.515-.013 3.339-.859 4.471-1.909 3.839-3.559 7.496-7.323 11.068-11.152.818-.878 1.432-2.328 1.441-3.519a2902.84 2902.84 0 0 0-.002-41.629c-.009-1.186-.655-2.626-1.479-3.504-3.715-3.962-7.554-7.813-11.463-11.585-.818-.789-2.121-1.518-3.205-1.524C36.268-.246 18.995-.218 1.722-.207 1.252-.207.783-.098 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(99.639 478.637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-14.216c-.051 1.109-.137 2.139-.138 3.169-.011 9.798-.072 19.597.042 29.394.027 2.26-.575 3.166-2.924 3.566-13.951 2.375-27.871 4.935-41.8 7.437-.437.078-.867.19-1.256.776h46.022v15.544h-56.699v14.443c.853.047 1.775.142 2.698.143 17.268.009 34.536.049 51.804-.071 1.431-.01 3.158-.792 4.227-1.779 3.845-3.551 7.503-7.31 11.142-11.077.665-.688 1.294-1.778 1.297-2.685C.262 39.555.234 20.25.217.945.217.76.135.575 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(336.08 479.392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.962-.053-1.816-.14-2.671-.141-11.545-.009-23.09-.069-34.633.073-1.439.018-3.182.786-4.239 1.784-3.876 3.659-7.577 7.511-11.207 11.417-.762.819-1.33 2.177-1.333 3.288-.072 28.231-.058 56.461-.047 84.692 0 .753.132 1.506.213 2.363h14.141V14.533H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(536.376 479.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.634-2.1-3.261-4.206-4.905-6.298-7.072-8.998-14.099-18.033-21.267-26.953-1.505-1.873-2.06-3.732-2.043-6.085.088-12.611-.002-25.222.084-37.832.015-2.092-.333-3.786-2.083-5.063-2.351-1.717-3.091-4.04-3.364-6.964-2.369-25.294-4.922-50.57-7.436-75.85-.151-1.51-.438-3.006-.995-4.477v74.508h-13.942v14.692h13.76v45.867h-13.507v14.365c4.931 0 9.846.248 14.708-.158 1.38-.115 2.652-2.086 3.878-3.302.753-.746 1.325-1.675 2.167-2.768L-.365.345 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(829.197 573.729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 32.09-24.743c.415.144.673.15.759.275 3.548 5.181 8.623 6.23 14.455 5.527 1.99-.241 4.034-.038 6.256-.038v-14.37H40.019v-45.813h13.886v-14.636H39.918v-74.403l-.571-.03c-.615 6.139-1.234 12.277-1.843 18.415-2.117 21.335-4.19 42.673-6.434 63.994-.149 1.417-1.331 2.987-2.472 3.98-2.099 1.826-2.732 3.862-2.702 6.602.139 12.616.119 25.234-.011 37.85-.017 1.583-.664 3.435-1.631 4.691-7.636 9.918-15.425 19.717-23.15 29.566C.48-2.338-.023-1.448-.582-.602L0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(181.925 572.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-14.208h-56.873v-60.221c-4.68 0-8.998-.084-13.304.12-.465.022-1.213 1.702-1.221 2.618-.088 10.089-.055 20.179-.055 30.269 0 8.247-.075 16.495.073 24.739.025 1.365.708 3.005 1.634 4.017 3.6 3.934 7.38 7.706 11.191 11.438.752.737 1.938 1.46 2.927 1.464C-37.389.309-19.15.273-.911.253-.729.252-.548.156 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(744.076 553.568)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiablerieLogo);
export default __webpack_public_path__ + "static/media/diablerie-logo.57c3b7a51558a4063f5f2294db95036a.svg";
export { ForwardRef as ReactComponent };